import { create } from "zustand";

/**
 * Field sync status the whole app can see: the unsynced badge in the nav,
 * and the service worker update, which must never reload over unsynced
 * work. The field capture code (src/field) owns the outbox and reports its
 * counts here with setCounts; nothing else writes to it.
 */
export interface SyncStatus {
  /** Events and photos waiting to upload. */
  pending: number;
  /** Items the server refused, waiting in "Needs attention". */
  rejected: number;
  lastSyncAt: number | null;
  setCounts: (counts: { pending: number; rejected?: number; lastSyncAt?: number | null }) => void;
}

export const useSyncStatus = create<SyncStatus>((set) => ({
  pending: 0,
  rejected: 0,
  lastSyncAt: null,
  setCounts: ({ pending, rejected, lastSyncAt }) =>
    set((s) => ({
      pending: Math.max(0, pending),
      rejected: rejected === undefined ? s.rejected : Math.max(0, rejected),
      lastSyncAt: lastSyncAt === undefined ? s.lastSyncAt : lastSyncAt,
    })),
}));

/** True when nothing is waiting to sync (an app update may reload safely). */
export function outboxIsEmpty(): boolean {
  const { pending, rejected } = useSyncStatus.getState();
  return pending === 0 && rejected === 0;
}
